import type { ParagraphDarkFeatures as ParagraphDarkFeaturesData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import { HtmlText } from "../shared/HtmlText";
import styles from "./ParagraphDarkFeatures.module.css";

/**
 * Layout 44 - `PARAGRAPH_DARK_FEATURES_LAYOUT`: dark features (dark full-bleed section).
 *
 * Struktura:
 *   - Dark full-bleed bg (chrome dark) z bialym tekstem
 *   - Zielony pill badge z zielonym dotem (text_1, np. "Nowość · wsparcie AI")
 *   - H2 (name) - tytul sekcji (bialy)
 *   - Lead (text) - paragraf pod tytulem (jasny szary)
 *   - Grid 3-kol z 9 kart:
 *       - Ikona (Nucleo, w boxie top-left)
 *       - Nazwa (H3, biala)
 *       - Opis (paragraph, jasny szary)
 *   - Puste sloty filtrowane po backendzie
 */
export function ParagraphDarkFeatures({
  paragraph,
}: {
  paragraph: ParagraphDarkFeaturesData;
  t: ParagraphTranslations;
}) {
  const { text_1: badge, name: title, text: lead, items } = paragraph;
  const hasBadge = badge && badge.trim() !== "";
  const hasLead = lead && lead.trim() !== "";
  const hasItems = Array.isArray(items) && items.length > 0;

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.header}>
          {hasBadge ? (
            <span className={styles.badge}>
              <span className={styles.badgeDot} aria-hidden="true" />
              {badge}
            </span>
          ) : null}
          {title ? <h2 className={styles.title}>{title}</h2> : null}
          {hasLead ? (
            <HtmlText html={lead} className={styles.lead} />
          ) : null}
        </div>

        {hasItems ? (
          <div className={styles.grid}>
            {items.map((it, idx) => (
              <div key={idx} className={styles.card}>
                {it.icon ? (
                  <div className={styles.iconBox} aria-hidden="true">
                    <i className={`nc-icon-outline ${it.icon}`} />
                  </div>
                ) : null}
                {it.name ? <h3 className={styles.name}>{it.name}</h3> : null}
                {it.desc ? <p className={styles.desc}>{it.desc}</p> : null}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
}
